"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var challengesApi_1 = require("../mock/challengesApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var ChallengesPIs = {
    getChallenges: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return challengesApi_1.mockChallenges; },
            url: "".concat(coreServiceUrl, "/challenges"),
            token: token,
        });
    },
    getChallengesUsersLeaderboard: function (token, challengeUuid, teamUuid) {
        return rest_1.default.get({
            mockFunc: function () { return challengesApi_1.mockChallengeUsersLeaderboard; },
            url: "".concat(coreServiceUrl, "/challenges/users-leaderboard").concat(challengeUuid ? "?challengeUuid=".concat(challengeUuid) : '').concat(challengeUuid ? '&' : '?').concat(teamUuid ? "teamUuid=".concat(teamUuid) : ''),
            token: token,
        });
    },
    getChallengesTeamsLeaderboard: function (token, challengeUuid) {
        if (challengeUuid === void 0) { challengeUuid = ''; }
        return rest_1.default.get({
            mockFunc: function () { return challengesApi_1.mockChallengeTeamsLeaderboard; },
            url: "".concat(coreServiceUrl, "/challenges/teams-leaderboard/").concat(challengeUuid),
            token: token,
        });
    },
};
exports.default = ChallengesPIs;
